import { render, staticRenderFns } from "./Writing.vue?vue&type=template&id=3cb2ca98&scoped=true"
import script from "./Writing.vue?vue&type=script&lang=js"
export * from "./Writing.vue?vue&type=script&lang=js"
import style0 from "./Writing.vue?vue&type=style&index=0&id=3cb2ca98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb2ca98",
  null
  
)

export default component.exports